import Table from "./containers/Table";

export const CELL_TYPES = {
  text: "text",
  number: "number",
  money: "money",
  enum: "enum",
  listOfEnum: "listOfEnum",
  ssn: "ssn",
  date: "date",
  percentage: "percentage",
  custom: "custom",
};

export default Table;
